import React, { useEffect, useState } from "react";
// Components
import { ConfigurationPanel } from "../..";
import { Delivery } from "./delivery";
import { Input, translateMessage } from "@delibrandev/utils";
import { Button } from "@delibrandev/utils";
// API
import { createDeliveryMethod, getDeliveryMethods, updateDeliveryMethod, deleteDeliveryMethod } from "../../../../../../api/deliveryMethods";
import { setAlert } from "../../../../../../reducers/userConfigSlice";
import { useDispatch } from "react-redux";

export const DeliveryMethods = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const query = async () => {
    const response = await getDeliveryMethods();
    if (response && !response.error) {
      console.log("DELIVERY", response.data);
      setData(response.data);
    }
  };

  const deleteMethod = async (id) => {
    console.log("Borrando");
    const response = await deleteDeliveryMethod(id);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log(response);
      query();
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Error en la operación");
    }
  };

  useEffect(() => {
    query();
  }, []);

  const createStoreDelivery = async (methodId = null) => {
    console.log("createStoreDelivery");
    console.log("methodId: " + methodId);
    const payload = {
      nameHomeDelivery: null,
      nameStoreDelivery: document.getElementById("NameStoreInput-" + methodId)?.value || "Recogida en tienda",
      shippingCost: null,
      storeDeliveryIsActive: true,
      homeDeliveryIsActive: false,
    };

    if (methodId !== null) {
      // Si existe un domicilioValues.id, hacemos un update
      const response = await updateDeliveryMethod(payload, methodId);
      if (response && !response.error) {
        console.log("Updated successfully:", response);
        query();
      }
    } else {
      // Si no existe, hacemos un create
      const response = await createDeliveryMethod(payload);
      if (response && !response.error) {
        console.log("Created successfully:", response);
        query();
      }
    }
  };

  const createHomeDelivery = async (methodId = null) => {
    const payload = {
      minimumPurchaseValue: document.getElementById("buyMinInput-" + methodId)?.value || null,
      nameHomeDelivery: document.getElementById("NameHomeInput-" + methodId)?.value || "Domicilio",
      nameStoreDelivery: null,
      shippingCost: document.getElementById("shippingCost-" + methodId)?.value || "0",
      storeDeliveryIsActive: false,
      homeDeliveryIsActive: true,
    };

    if (methodId !== null) {
      // Si existe un tiendaValues.id, hacemos un update
      const response = await updateDeliveryMethod(payload, methodId);
      if (response && !response.error) {
        console.log("Updated successfully:", response);
        query();
      }
    } else {
      console.log("NO EXISTE");
      // Si no existe, hacemos un create
      const response = await createDeliveryMethod(payload);
      console.log(response);
      if (response && !response.error) {
        console.log("Created successfully:", response);
        query();
      }
    }
  };

  const HomePanel = ({ data }) => {
    const [requirementType, setRequirementType] = useState("none");
    useEffect(() => {
      data.minimumPurchaseValue !== null && setRequirementType("minValue");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div className="row">
        <div className="col-12 mb-3">
          <Input
            id={"NameHomeInput-" + data.shippingMethodId}
            type={"text"}
            placeholder="Domicilio"
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Título"
            description=""
            defaultValue={data.nameHomeDelivery || ""}
          />
        </div>
        <div className="col-md-12 col-sm-12">
          <Input
            id={"shippingCost-" + data.shippingMethodId}
            type={"text"}
            placeholder="0"
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Coste del envío"
            description=""
            defaultValue={data.shippingCost || ""}
          />
        </div>
        <div className="col-12">
          <div className="mt-2 mb-2">
            <b>Requisitos para el envío</b>
          </div>
          <div className="form">
            <div className="flex-start" style={{ gap: "10px" }}>
              <input type="radio" name="buymin" value="none" checked={requirementType === "none"} onChange={() => setRequirementType("none")} /> No
              hay requisitos
            </div>
            <div className="flex-start" style={{ gap: "10px" }}>
              <input
                type="radio"
                name="buymin"
                value="minValue"
                checked={requirementType === "minValue"}
                onChange={() => setRequirementType("minValue")}
              />{" "}
              Compra mínima
            </div>
            <div className="mt-3">
              {requirementType === "minValue" && (
                <Input
                  id={"buyMinInput-" + data.shippingMethodId}
                  type={"text"}
                  placeholder="10"
                  icon={null}
                  classname={"buyMinInput w-100"}
                  iconPositionRight={true}
                  label=""
                  description=""
                  defaultValue={data.minimumPurchaseValue || ""}
                />
              )}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="flex-end w-100 mt-3">
            <Button
              key={"Eliminar"}
              text={"Eliminar"}
              icon={null}
              action={() => deleteMethod(data.shippingMethodId, data)}
              customClass={"customButtonRed"}
            />
          </div>
        </div>
      </div>
    );
  };

  const StorePanel = ({ data }) => {
    return (
      <div className="row">
        <div className="col-12">
          <Input
            id={"NameStoreInput-" + data.shippingMethodId}
            type={"text"}
            placeholder="Recogida en tienda"
            icon={null}
            classname={""}
            iconPositionRight={true}
            label="Título"
            description=""
            defaultValue={data.nameStoreDelivery || ""}
          />
        </div>

        <div className="col-12">
          <div className="flex-end w-100 mt-3">
            <Button
              key={"Eliminar"}
              text={"Eliminar"}
              icon={null}
              action={() => deleteMethod(data.shippingMethodId, data)}
              customClass={"customButtonRed"}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ConfigurationPanel
        title="Métodos de entrega y envío"
        content={
          <>
            <div className="paymentsMethodsBlock">
              <Delivery
                handleMethod={() => createHomeDelivery(null)}
                activeMethod={null}
                delivery={{ homeDeliveryIsActive: true, nameHomeDelivery: "Domicilio" }}
              />
              <Delivery
                handleMethod={() => createStoreDelivery(null)}
                activeMethod={null}
                delivery={{ storeDeliveryIsActive: true, nameStoreDelivery: "Recogida en tienda" }}
              />
            </div>
          </>
        }
        hasButtonSave={false}
      />
      <div className="row">
        {data?.map((method) => (
          <div className="col-4" key={method.shippingMethodId}>
            <ConfigurationPanel
              title={method.homeDeliveryIsActive ? "Domicilio" : "Local"}
              content={method.homeDeliveryIsActive ? <HomePanel data={method} /> : <StorePanel data={method} />}
              action={
                method.homeDeliveryIsActive ? () => createHomeDelivery(method.shippingMethodId) : () => createStoreDelivery(method.shippingMethodId)
              }
            />
          </div>
        ))}
      </div>
    </>
  );
};
